// EducationExperience Assets
import SXCALogo from "../Assets/EducationExperience/SXCALogo.png";
import RJJLogo from "../Assets/EducationExperience/RJJ-Logo.png";
import TCSLogo from "../Assets/EducationExperience/TCS-removebg-preview.png";
import TCSCerti from "../Assets/EducationExperience/TCSCerti.jpg";
import favicon from "../Assets/EducationExperience/favicon.svg";

// Project Assets
import PortfolioWebsite from "../Assets/Projects/PortfolioWebsite.png";
import QRCodeWebsite from "../Assets/Projects/QRCodeWebsite.png";
import MovieRecommendorWebsite from "../Assets/Projects/MovieRecommendorWebsite.png";
import ComingSoon from "../Assets/Projects/ComingSoon.jpg";
import GulabClinic from "../Assets/Projects/GulabClinic.png";

// Skills Assets
import pythonSVG from "../Assets/Skills/python.svg";
// import mysqlSVG from "../Assets/Skills/mysql.svg";
import mongoDBSVG from "../Assets/Skills/mongodb.svg";
// import nodeSVG from "../Assets/Skills/node.svg";
// import expressSVG from "../Assets/Skills/express.svg";
import reactSVG from "../Assets/Skills/react.svg";
import dockerSVG from "../Assets/Skills/docker.svg";
import githubPNG from "../Assets/Skills/github-mark-white.svg";
import postmanSVG from "../Assets/Skills/postman.svg";
import netlifySVG from "../Assets/Skills/netlify.svg";
import javaSVG from "../Assets/Skills/java.svg";
import SpringBootSVG from "../Assets/Skills/SpringBoot.svg";
import MicroservicesSVG from "../Assets/Skills/Microservices.png";
import KafkaSVG from "../Assets/Skills/Kafka.png";

export const Bio = {
	name: "Dishang Mehta",
	roles: ["Programmer", "Data Scientist", "Java Developer"],
	description:
		"I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
	github: "https://github.com/DishangMehta11",
	resume:
		"https://drive.google.com/file/d/1hTvhQK-1aoJ2FRFciKzPaPGiOsWvoeK9/view?usp=sharing",
	linkedin: "https://www.linkedin.com/in/dishang-mehta/",
	twitter: "https://twitter.com/dmehta624",
	insta: "https://www.instagram.com/dishang_mehta11/",
	email: "contact@portfolio.dishangmehta12.me",
};

export const skills = [
	{
		title: "Frontend",
		skills: [
			{
				name: "React Js",
				image: reactSVG,
				// "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
			},
			// {
			// 	name: "Redux",
			// 	image:
			// 		"https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
			// },
			// {
			// 	name: "Next Js",
			// 	image:
			// 		"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
			// },
			{
				name: "HTML",
				image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
			},
			{
				name: "CSS",
				image:
					"https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
			},
			{
				name: "JavaScript",
				image:
					"https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
			},
			{
				name: "Bootstrap",
				image:
					"https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
			},
			// {
			// 	name: "Material UI",
			// 	image:
			// 		"data:image/png;base64,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",
			// },
			// {
			// 	name: "Flutter",
			// 	image:
			// 		"https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
			// },
		],
	},
	{
		title: "Backend",
		skills: [
			{
				name: "Spring Boot",
				image: SpringBootSVG,
				//nodeSVG,
			},
			{
				name: "Microservices",
				image: MicroservicesSVG,
				// image: "data:image/png;base64,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",
				//nodeSVG,
			},
			{
				name: "Java",
				image: javaSVG,
				//nodeSVG,
			},
			{
				name: "Kafka",
				image: KafkaSVG,
				//nodeSVG,
			},
			// {
			// 	name: "Node Js",
			// 	image: "https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg",
			// 	//nodeSVG,
			// },
			// {
			// 	name: "Express Js",
			// 	image: expressSVG,
			// 	// image: "https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg",
			// 	//"data:image/png;base64,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",
			// },
			// {
			// 	name: "Graph Ql",
			// 	image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
			// },
			{
				name: "Python",
				image: pythonSVG,
			},
			{
				name: "MySQL",
				image: "https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg",
			},
			{
				name: "Postgresql",
				image: "https://www.postgresql.org/media/img/about/press/elephant.png",
			},
			{
				name: "MongoDB",
				image: mongoDBSVG,
			},
			// {
			// 	name: "Firebase",
			// 	image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
			// },
		],
	},
	// {
	// 	title: "Android",
	// 	skills: [
	// 		{
	// 			name: "Java",
	// 			image:
	// 				"https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
	// 		},
	// 		{
	// 			name: "Kotlin",
	// 			image:
	// 				"https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
	// 		},
	// 		{
	// 			name: "XML",
	// 			image:
	// 				"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
	// 		},
	// 		{
	// 			name: "Android Studio",
	// 			image:
	// 				"https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
	// 		},
	// 	],
	// },
	{
		title: "Others",
		skills: [
			{
				name: "Git",
				image:
					"https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg",
			},
			{
				name: "GitHub",
				// image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
				image: githubPNG,
			},
			{
				name: "Docker",
				image: dockerSVG,
			},
			{
				name: "Netlify",
				image: netlifySVG,
				// "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
			},
			{
				name: "VS Code",
				image:
					"https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
			},
			{
				name: "Postman",
				image: postmanSVG,
			},
			// {
			// 	name: "Adobe XD",
			// 	image:
			// 		"https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
			// },
			// {
			// 	name: "Figma",
			// 	image:
			// 		"https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
			// },
		],
	},
];

export const experiences = [
	{
		id: 0,
		img: TCSLogo,
		role: "Data Analyst Intern",
		company: "Tata Consultancy Services Pvt. Ltd.",
		date: "Feb 2023 - July 2023",
		desc: "Worked as Risk Analyst Intern responsible for assessing various parameters associated with client.",
		skills: ["SAS Studio", "SAS Enterprise", "Banking Services"],
		doc: TCSCerti,
	},
	{
		id: 1,
		img: TCSLogo,
		role: "System Engineer",
		company: "Tata Consultancy Services Pvt. Ltd.",
		date: "Nov 2023 - Sept 2025",
		desc: "Developed and optimized over 15+ RESTful APIs using Java and Spring Boot, improving backend performance and responsiveness. Troubleshot and resolved production-level issues, enhancing application uptime, system stability, and overall system reliability. Built reusable backend modules using MVC architecture, improving maintainability and reducing redundant code. Used SVN for version control, managing code changes and ensuring smooth collaboration within the team. Worked with MySQL databases to generate business reports, supporting operational and analytical needs.",
		// skills: ["SAS Studio", "SAS Enterprise", "Banking Services"],
		// doc: TCSCerti,
	},
	{
		id: 2,
		img: favicon,
		role: "Software Developer",
		company: "Freelancer",
		date: "Oct 2025 - Dec 2025",
		desc: "Built secure, stateless authentication and authorization using Spring Security, Google OAuth2 via Google Cloud Platform (GCP) APIs, and JWT, enabling seamless login with Google accounts and scalable session management. Implemented CRUD operations for patient profiles and follow-up sessions, with image upload and retrieval through Cloudinary. Deployed the React.js frontend as a static site on Render and Spring Boot backend as a containerized web service, using Docker by setting up a Continuous Integration/Continuous Delivery (CI/CD) pipeline using GitHub actions to automate deployment workflow on Render using webhooks. Engaged directly with client to gather requirements, served as sole developer - responsible for end-to-end architecture,development, deployment, and automation ensuring timely project delivery.",
	},
];

export const education = [
	{
		id: 0,
		img: SXCALogo,
		school: "St. Xavier's Autonomous College, Ahmedabad",
		date: "Oct 2021 - Jul 2023",
		grade: "8.71 CGPA",
		desc: "I have completed my post graduation at SXCA in Master of Science specializing in Big Data Analytics(BDA)",
		degree: "Master of Science - M. Sc. (Big Data Analytics)",
	},
	{
		id: 1,
		img: SXCALogo,
		school: "St. Xavier's Autonomous College, Ahmedabad",
		date: "Jun 2018 - Apr 2021",
		grade: "88.2%",
		desc: "I completed graduation at SXCA in Bachelor of Science speciaizing in Mathematics",
		degree: "Bachelor of Science - B. Sc. (Mathematics)",
	},
	{
		id: 2,
		img: RJJLogo,
		school: "Sett R. J. J. High School",
		date: "Jun 2017 - Mar 2018",
		grade: "76.34%",
		desc: "I completed my class 12 education at Sett R. J. J. High School, Valsad, where I studied Science.",
		degree: "GSEB(XII), Science",
	},
	{
		id: 3,
		img: RJJLogo,
		school: "Sett R. J. J. High School",
		date: "Jun 2015 - Mar 2016",
		grade: "90.0%",
		desc: "I completed my class 10 education at Sett R. J. J. High School, Valsad.",
		degree: "GSEB(XII), Science",
	},
];

export const projects = [
	{
		id: 9,
		title: "Portfolio",
		// date: "Jun 2023 - Jul 2023",
		description:
			"This is a portfolio website for myself and a good practice project for learning React JS",
		// "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
		image: PortfolioWebsite,
		tags: [
			"Docker",
			// "AWS",
			// "DuckDNS",
			"Eslint",
			// "Husky",
			// "CI/CD",
			"React Js",
			// "MongoDb",
			// "Node Js",
			// "Express Js",
			// "Redux",
		],
		category: "web app",
		github: "https://github.com/DishangMehta11/react-portfolio",
		webapp: "https://dishangmehta12.me",
	},
	{
		id: 0,
		title: "Patient Management System",
		description:
			"A full-stack CRUD application built using Spring Boot and React for managing clinic operations. The system maintains patient profiles, visit records, and associated medical images. It provides quick search and structured record-keeping, helping the doctor track patient history and follow-ups efficiently. The project was developed for a real client and is actively used in a clinic environment.",
		image: GulabClinic,
		tags: ["Spring Boot", "React", "MySQL", "Cloudinary"],
		category: "web app",
		github: "https://github.com/DishangMehta11/GulabClinicV1",
		webapp: "https://gulabclinic.dishangmehta12.me",
	},
	{
		id: 1,
		title: "Custom QR Generator",
		description:
			"This is a basic flask web application which can help you create your own custom QR Codes with custom parameters such as error correction, box sizing, colors and more.",
		image: QRCodeWebsite,
		tags: ["Flask", "Tailblocks", "python-qrcode"],
		category: "web app",
		github: "https://github.com/DishangMehta11/CustomQRGeneratorFlask",
		webapp: "https://dishangmehta11.pythonanywhere.com/",
	},
	{
		id: 2,
		title: "Movie Recommender System",
		description:
			"Movie Recommender System using Machine Learning and streamlit for the website creation",
		image: MovieRecommendorWebsite,
		tags: ["streamlit"],
		category: "machine learning",
		github: "https://github.com/DishangMehta11/Movie-Recommendation-System/",
		webapp: "https://github.com/DishangMehta11/Movie-Recommendation-System/",
	},
	{
		id: 3,
		title: "Virtual Painter",
		description:
			"A Virtual Painter! Just grab a normal camera and start painting with your finger itself. Forget the hassle of mouse and costly wacoms. Just start paining with your finger",
		image: ComingSoon,
		tags: ["CVZone", "MediaPipe", "opencv-python"],
		category: "computer vision",
		github:
			"https://github.com/DishangMehta11/Hand-Gestures/blob/main/Virtual_Painter.py",
		webapp:
			"https://github.com/DishangMehta11/Hand-Gestures/blob/main/Virtual_Painter.py",
	},
	{
		id: 99,
		title: "Many more yet to be added",
		description:
			"A many more projects few of which are yet to be deployed and few are under some finishing touch",
		image: ComingSoon,
	},
	// {
	// 	id: 0,
	// 	title: "Podstream",
	// 	date: "Apr 2023 - May 2023",
	// 	description:
	// 		"Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
	// 	image:
	// 		"https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
	// 	tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
	// 	category: "web app",
	// 	github: "https://github.com/rishavchanda/Podstream",
	// 	webapp: "https://podstream.netlify.app/",
	// 	member: [
	// 		{
	// 			name: "Rishav Chanda",
	// 			img: "https://avatars.githubusercontent.com/u/64485885?v=4",
	// 			linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
	// 			github: "https://github.com/rishavchanda/",
	// 		},
	// 		{
	// 			name: "Upasana Chaudhuri",
	// 			img: "https://avatars.githubusercontent.com/u/100614635?v=4",
	// 			linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
	// 			github: "https://github.com/upasana0710",
	// 		},
	// 	],
	// },
	// {
	// 	id: 1,
	// 	title: "Vexa",
	// 	date: "Oct 2022 - Present",
	// 	description:
	// 		"Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
	// 	image:
	// 		"https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
	// 	tags: [
	// 		"React Js",
	// 		"MongoDb",
	// 		"Node Js",
	// 		"Express Js",
	// 		"Redux",
	// 		"NodeMailer",
	// 	],
	// 	category: "web app",
	// 	github: "https://github.com/rishavchanda/Project-Management-App",
	// 	webapp: "https://vexa-app.netlify.app/",
	// },
	// {
	// 	id: 2,
	// 	title: "Brain Tumor Detection",
	// 	date: "Jan 2023 - Mar 2023",
	// 	description:
	// 		"Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
	// 	image:
	// 		"https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
	// 	tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
	// 	category: "machine learning",
	// 	github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
	// 	webapp: "https://brain-tumor.netlify.app/",
	// 	member: [
	// 		{
	// 			name: "Rishav Chanda",
	// 			img: "https://avatars.githubusercontent.com/u/64485885?v=4",
	// 			linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
	// 			github: "https://github.com/rishavchanda/",
	// 		},
	// 		{
	// 			name: "Upasana Chaudhuri",
	// 			img: "https://avatars.githubusercontent.com/u/100614635?v=4",
	// 			linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
	// 			github: "https://github.com/upasana0710",
	// 		},
	// 	],
	// },
	// {
	// 	id: 3,
	// 	title: "Buckoid",
	// 	date: "Dec 2021 - Apr 2022",
	// 	description:
	// 		"App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
	// 	image:
	// 		"https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
	// 	tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
	// 	category: "android app",
	// 	github: "https://github.com/rishavchanda/Buckoid-Android-App",
	// 	webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
	// },
	// {
	// 	id: 10,
	// 	title: "Job Finding App",
	// 	date: "Jun 2023 - Jul 2023",
	// 	description:
	// 		"A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
	// 	image:
	// 		"https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
	// 	tags: ["React Native", "JavaScript", "Axios"],
	// 	category: "android app",
	// 	github: "https://github.com/rishavchanda/Job-finder-App",
	// 	webapp: "https://github.com/rishavchanda/Job-finder-App",
	// },
	// {
	// 	id: 4,
	// 	title: "Whatsapp Clone",
	// 	date: "Jul 2021",
	// 	description:
	// 		"A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
	// 	image:
	// 		"https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
	// 	tags: ["React Js", "Firebase", "Firestore", "Node JS"],
	// 	category: "web app",
	// 	github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
	// 	webapp: "https://whatsapp-clone-rishav.web.app",
	// },
	// {
	// 	id: 5,
	// 	title: "Todo Web App",
	// 	date: "Jun 2021",
	// 	description:
	// 		" A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
	// 	image:
	// 		"https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
	// 	tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
	// 	category: "web app",
	// 	github: "https://github.com/rishavchanda/Todo-Web-App",
	// 	webapp: "https://rishav-react-todo.netlify.app/",
	// },
	// {
	// 	id: 6,
	// 	title: "Breaking Bad",
	// 	date: "Jun 2021",
	// 	description:
	// 		"A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
	// 	image:
	// 		"https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
	// 	tags: ["React Js", "API", "Axios", "Node JS"],
	// 	category: "web app",
	// 	github: "https://github.com/rishavchanda/Breaking-Bad",
	// 	webapp: "https://breaking-bad-webapp.netlify.app",
	// },
	// {
	// 	id: 7,
	// 	title: "Quiz App",
	// 	date: "Dec 2020 - Jan 2021",
	// 	description:
	// 		"A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
	// 	image:
	// 		"https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
	// 	tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
	// 	category: "android app",
	// 	github: "https://github.com/rishavchanda/Quiz-Earn",
	// 	webapp: "https://github.com/rishavchanda/Quiz-Earn",
	// },
	// {
	// 	id: 8,
	// 	title: "Face Recognition",
	// 	date: "Jan 2021",
	// 	description:
	// 		"A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
	// 	image:
	// 		"https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
	// 	tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
	// 	category: "machine learning",
	// 	github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
	// 	webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
	// },
];

export const TimeLineData = [
	{ year: 2017, text: "Started my journey" },
	{ year: 2018, text: "Worked as a freelance developer" },
	{ year: 2019, text: "Founded JavaScript Mastery" },
	{ year: 2020, text: "Shared my projects with the world" },
	{ year: 2021, text: "Started my own platform" },
];
